<div class="cm-left-navigation">
    @let can = $can();
    @let orgQueryParams = $organizationQueryParams();
    <!-- File input for profile picture upload - kept outside menus to prevent DOM recreation issues -->
    <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" class="cm-file-input" />

    <div class="cm-nav-group">
        <a class="cm-menu-item" [routerLink]="[Routes.Home]" [queryParams]="orgQueryParams">
            @if (isRouteActive(Routes.Home)) {
                <i class="fas fa-house cm-menu-item-icon cm-menu-item-icon-active"></i>
            } @else {
                <i class="far fa-house cm-menu-item-icon"></i>
            }
            Home
        </a>
        <a class="cm-menu-item" [routerLink]="[Routes.Materials]" [queryParams]="orgQueryParams">
            @if (isRouteActive(Routes.Materials)) {
                <i class="fas fa-game-board-simple cm-menu-item-icon cm-menu-item-icon-active"></i>
            } @else {
                <i class="far fa-game-board-simple cm-menu-item-icon"></i>
            }
            Materials
        </a>
        @if ($showOnlineLinks()) {
            <!-- Online mode: Products and Scenes -->
            @if (can.read.menu("products")) {
                <a class="cm-menu-item" [routerLink]="[Routes.Products]" [queryParams]="orgQueryParams">
                    @if (isRouteActive(Routes.Products)) {
                        <i class="fas fa-chair cm-menu-item-icon cm-menu-item-icon-active"></i>
                    } @else {
                        <i class="far fa-chair cm-menu-item-icon"></i>
                    }
                    Products
                </a>
            }
            @if (can.read.menu("scenes")) {
                <a class="cm-menu-item" [routerLink]="[Routes.Scenes]" [queryParams]="orgQueryParams">
                    @if (isRouteActive(Routes.Scenes)) {
                        <i class="fas fa-lightbulb cm-menu-item-icon cm-menu-item-icon-active"></i>
                    } @else {
                        <i class="far fa-lightbulb cm-menu-item-icon"></i>
                    }
                    Scenes
                </a>
            }
        } @else {
            <!-- Offline mode: Models and Assets -->
            @if (can.read.menu("models")) {
                <a class="cm-menu-item" [routerLink]="[Routes.Models]" [queryParams]="orgQueryParams">
                    @if (isRouteActive(Routes.Models)) {
                        <i class="fas fa-cube cm-menu-item-icon cm-menu-item-icon-active"></i>
                    } @else {
                        <i class="far fa-cube cm-menu-item-icon"></i>
                    }
                    Models
                </a>
            }
            @if (can.read.menu("assets")) {
                <a class="cm-menu-item" [routerLink]="[Routes.Assets]" [queryParams]="orgQueryParams">
                    @if (isRouteActive(Routes.Assets)) {
                        <i class="fas fa-couch cm-menu-item-icon cm-menu-item-icon-active"></i>
                    } @else {
                        <i class="far fa-couch cm-menu-item-icon"></i>
                    }
                    Assets
                </a>
            }
        }

        <div class="cm-menu-item cm-hide-on-mobile" [cdkMenuTriggerFor]="menuOther" [cdkMenuPosition]="menuPositionCreate">
            @if ($isOtherRouteActive()) {
                <i class="fas fa-ellipsis cm-menu-item-icon cm-menu-item-icon-active"></i>
            } @else {
                <i class="far fa-ellipsis cm-menu-item-icon"></i>
            }
            Other
        </div>

        <ng-template #menuOther>
            <div class="cm-overlay-container cm-create-menu" cdkMenu>
                @if (can.read.menu("scanning") || can.read.menu("tags")) {
                    <div class="cm-section">
                        <div class="cm-section-title">Pinned</div>
                        @if (can.read.menu("scanning")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.Scanning]" routerLinkActive="cm-section-item-active">
                                <i class="far fa-aperture cm-icon-default"></i>
                                Scanning
                            </a>
                        }
                        @if (can.read.menu("tags")) {
                            <a
                                class="cm-section-item"
                                cdkMenuItem
                                [routerLink]="[Routes.Tags]"
                                routerLinkActive="cm-section-item-active"
                                [queryParams]="orgQueryParams"
                            >
                                <i class="far fa-tag cm-icon-default"></i>
                                Tags
                            </a>
                        }
                    </div>
                    <div class="cm-horizontal-line"></div>
                }
                @if ($can().read.menu("organizations") || $can().read.menu("users") || $can().read.menu("organizationGroups")) {
                    <div class="cm-section">
                        <div class="cm-section-title">Organization</div>
                        @if (can.read.menu("organizations")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.Organizations]" routerLinkActive="cm-section-item-active">
                                <i class="far fa-building cm-icon-default"></i>
                                Organizations
                            </a>
                        }
                        @if ($can().read.menu("organizationGroups")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.OrganizationGroups]" routerLinkActive="cm-section-item-active">
                                <i class="far fa-buildings cm-icon-default"></i>
                                Organization Groups
                            </a>
                        }
                        @if (can.read.menu("users")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.Users]" routerLinkActive="cm-section-item-active">
                                <i class="far fa-user-friends cm-icon-default"></i>
                                Users
                            </a>
                        }
                    </div>
                    <div class="cm-horizontal-line"></div>
                }
                <div class="cm-section">
                    <div class="cm-section-title">3D Assets</div>
                    <a
                        class="cm-section-item"
                        cdkMenuItem
                        [routerLink]="[Routes.AllMaterials]"
                        [class.cm-section-item-active]="$isShowingAllMaterials()"
                        [queryParams]="orgQueryParams"
                    >
                        <i class="far fa-game-board-alt cm-icon-default"></i>
                        All Materials
                    </a>
                    <a
                        class="cm-section-item"
                        cdkMenuItem
                        [routerLink]="[Routes.Templates]"
                        routerLinkActive="cm-section-item-active"
                        [queryParams]="orgQueryParams"
                    >
                        <i class="far fa-chair cm-icon-default"></i>
                        All Templates
                    </a>
                    @if (can.read.menu("hdris")) {
                        <a
                            class="cm-section-item"
                            cdkMenuItem
                            [routerLink]="[Routes.Hdris]"
                            routerLinkActive="cm-section-item-active"
                            [queryParams]="orgQueryParams"
                        >
                            <i class="far fa-lightbulb cm-icon-default"></i>
                            HDRIs
                        </a>
                    }
                </div>
                @if ($canSeeJobsMenu()) {
                    <div class="cm-horizontal-line"></div>
                    <div class="cm-section">
                        <div class="cm-section-title">Task System</div>
                        @if (can.read.menu("jobs")) {
                            <a
                                class="cm-section-item"
                                cdkMenuItem
                                [routerLink]="[Routes.RenderJobs]"
                                routerLinkActive="cm-section-item-active"
                                [queryParams]="orgQueryParams"
                            >
                                <i class="far fa-gears cm-icon-default"></i>
                                Jobs
                            </a>
                        }
                        @if (can.read.menu("jobFarmInstances")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.RenderNodes]" routerLinkActive="cm-section-item-active">
                                <i class="far fa-server cm-icon-default"></i>
                                Render Nodes
                            </a>
                        }
                        @if (can.read.menu("jobFarmGroups")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.RenderNodeGroups]" routerLinkActive="cm-section-item-active">
                                <i class="far fa-network-wired cm-icon-default"></i>
                                Render Node Groups
                            </a>
                        }
                        @if (can.read.menu("taskTypes")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.TaskTypes]" routerLinkActive="cm-section-item-active">
                                <i class="far fa-receipt cm-icon-default"></i>
                                Task Types
                            </a>
                        }
                    </div>
                }
            </div>
        </ng-template>

        <div class="cm-menu-item cm-create" [cdkMenuTriggerFor]="menuCreate" [cdkMenuPosition]="menuPositionCreate">
            <i class="far fa-plus cm-create-icon cm-menu-item-icon"></i>
            Create
        </div>
        <ng-template #menuCreate>
            <div class="cm-overlay-container cm-create-menu" cdkMenu>
                <div class="cm-section">
                    <div class="cm-section-title">Outputs</div>
                    <a class="cm-section-item" cdkMenuItem (click)="navigateToCreatePicture($event)">
                        <i class="far fa-image cm-icon-create-default"></i>
                        <i class="far fa-plus cm-icon-create-hover"></i>
                        Image
                    </a>

                    <a class="cm-section-item" cdkMenuItem (click)="navigateToCreatePicture($event)">
                        <i class="far fa-cube cm-icon-create-default"></i>
                        <i class="far fa-plus cm-icon-create-hover"></i>
                        Configurator
                    </a>
                </div>
                <div class="cm-horizontal-line"></div>
                <div class="cm-section">
                    <div class="cm-section-title">Components</div>
                    @if (can.read.menu("materials")) {
                        <a
                            class="cm-section-item"
                            cdkMenuItem
                            [routerLink]="[Routes.CreateMaterial]"
                            [queryParams]="orgQueryParams"
                            queryParamsHandling="merge"
                        >
                            <i class="far fa-game-board-simple cm-icon-create-default"></i>
                            <i class="far fa-plus cm-icon-create-hover"></i>
                            Material
                        </a>
                    }
                    @if (can.read.menu("models") && !$showOnlineLinks()) {
                        <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateModel]" [queryParams]="orgQueryParams" queryParamsHandling="merge">
                            <i class="far fa-cube cm-icon-default"></i>
                            Model
                        </a>
                    }
                    @if (can.read.menu("assets") && !$showOnlineLinks()) {
                        <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateAsset]" [queryParams]="orgQueryParams" queryParamsHandling="merge">
                            <i class="far fa-couch cm-icon-create-default"></i>
                            <i class="far fa-plus cm-icon-create-hover"></i>
                            Asset
                        </a>
                    }
                    @if (can.read.menu("products")) {
                        <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateProduct]" [queryParams]="orgQueryParams" queryParamsHandling="merge">
                            <i class="far fa-chair cm-icon-create-default"></i>
                            <i class="far fa-plus cm-icon-create-hover"></i>
                            Product
                        </a>
                    }
                    @if (can.read.menu("scenes")) {
                        <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateScene]" [queryParams]="orgQueryParams" queryParamsHandling="merge">
                            <i class="far fa-lightbulb cm-icon-create-default"></i>
                            <i class="far fa-plus cm-icon-create-hover"></i>
                            Scene
                        </a>
                    }
                </div>
                @if (can.read.menu("tags")) {
                    <div class="cm-horizontal-line"></div>
                    <div class="cm-section">
                        <div class="cm-section-title">Other</div>
                        <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateTag]" queryParamsHandling="preserve">
                            <i class="far fa-tag cm-icon-create-default"></i>
                            <i class="far fa-plus cm-icon-create-hover"></i>
                            Tag
                        </a>
                    </div>
                }
                @if ($can().read.menu("organizations") || $can().read.menu("users") || $can().read.menu("organizationGroups")) {
                    <div class="cm-horizontal-line"></div>
                    <div class="cm-section">
                        <div class="cm-section-title">Organization</div>
                        @if (can.read.menu("organizations")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateOrganization]" queryParamsHandling="preserve">
                                <i class="far fa-building cm-icon-create-default"></i>
                                <i class="far fa-plus cm-icon-create-hover"></i>
                                Organization
                            </a>
                        }
                        @if ($can().read.menu("organizationGroups")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateOrganizationGroup]" queryParamsHandling="preserve">
                                <i class="far fa-buildings cm-icon-create-default"></i>
                                <i class="far fa-plus cm-icon-create-hover"></i>
                                Organization Group
                            </a>
                        }
                        @if (can.read.menu("users")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateUser]" queryParamsHandling="preserve">
                                <i class="far fa-user-plus cm-icon-create-default"></i>
                                <i class="far fa-plus cm-icon-create-hover"></i>
                                User
                            </a>
                        }
                    </div>
                }
                @if (can.read.menu("hdris")) {
                    <div class="cm-horizontal-line"></div>
                    <div class="cm-section">
                        <div class="cm-section-title">3D Assets</div>
                        <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateHdri]" queryParamsHandling="preserve">
                            <i class="far fa-lightbulb cm-icon-create-default"></i>
                            <i class="far fa-plus cm-icon-create-hover"></i>
                            HDRI
                        </a>
                    </div>
                }
                @if (can.read.menu("taskTypes") || can.read.menu("jobFarmGroups")) {
                    <div class="cm-horizontal-line"></div>
                    <div class="cm-section">
                        <div class="cm-section-title">Task System</div>
                        @if (can.read.menu("taskTypes")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateTaskType]" queryParamsHandling="preserve">
                                <i class="far fa-receipt cm-icon-create-default"></i>
                                <i class="far fa-plus cm-icon-create-hover"></i>
                                Task Type
                            </a>
                        }
                        @if (can.read.menu("jobFarmGroups")) {
                            <a class="cm-section-item" cdkMenuItem [routerLink]="[Routes.CreateRenderNodeGroup]" queryParamsHandling="preserve">
                                <i class="far fa-server cm-icon-create-default"></i>
                                <i class="far fa-plus cm-icon-create-hover"></i>
                                Render Node Group
                            </a>
                        }
                    </div>
                }
            </div>
        </ng-template>
    </div>
    <div class="cm-nav-group">
        @if (can.update.menu("online")) {
            <div class="cm-toggle-container">
                <cm-toggle [toggle]="$navigationMode() === 'online'" (toggleChange)="toggleNavigationMode()"></cm-toggle>
            </div>
        }
        <div class="cm-menu-item cm-hide-on-mobile" [cdkMenuTriggerFor]="menuHelp" [cdkMenuPosition]="menuPositionCreate" (cdkMenuOpened)="refreshDownloads()">
            <i class="far fa-question-circle cm-menu-item-icon cm-question-icon"></i>
        </div>
        <div
            class="cm-menu-item"
            [cdkMenuTriggerFor]="auth.$user() ? menuUser : null"
            [cdkMenuPosition]="menuPositionUser"
            [class.cm-menu-item-disabled]="!auth.$user()"
        >
            @if (auth.$user()?.galleryImage) {
                <cm-user-thumbnail class="cm-user-menu-thumbnail" size="100%" [user]="auth.$user()" [rounded]="false"></cm-user-thumbnail>
            } @else {
                <i class="far fa-user cm-user-icon cm-menu-item-icon"></i>
            }
        </div>
    </div>
    <ng-template #menuHelp>
        <div class="cm-overlay-container cm-create-menu" cdkMenu>
            <div class="cm-section">
                <div class="cm-section-title">Help</div>
                <a class="cm-section-item cm-discord" cdkMenuItem href="https://discord.gg/eMN96WkUvx" target="_blank">
                    <i class="fa-brands fa-discord cm-icon-default"></i>
                    Join our Discord
                </a>
                <a class="cm-section-item" cdkMenuItem href="https://docs.colormass.com/" target="_blank">
                    <i class="far fa-book cm-icon-default"></i>
                    Read the Docs
                </a>
                <a class="cm-section-item" cdkMenuItem href="https://discord.gg/eMN96WkUvx" target="_blank">
                    <i class="far fa-message cm-icon-default"></i>
                    Submit Bug or Feature
                </a>
                @if ($renderServerDownloadsLoading()) {
                    <div class="cm-section-item cm-section-item-loading" cdkMenuItem cdkMenuItemDisabled>
                        <i class="far fa-spinner fa-spin cm-icon-default"></i>
                        Download Render Server
                    </div>
                } @else if ($renderServerDownloads().length > 0) {
                    <div class="cm-section-item" cdkMenuItem [cdkMenuTriggerFor]="menuRenderServerDownload" [cdkMenuPosition]="menuPositionCreate">
                        <i class="far fa-download cm-icon-default"></i>
                        Download Render Server
                        @if ($renderServerVersion(); as renderServerVersion) {
                            ({{ renderServerVersion }})
                        }
                    </div>
                }
                @if ($blenderAddonDownloadLoading()) {
                    <div class="cm-section-item cm-section-item-loading" cdkMenuItem cdkMenuItemDisabled>
                        <i class="far fa-spinner fa-spin cm-icon-default"></i>
                        Download Blender Addon
                    </div>
                } @else if ($blenderAddonDownload(); as blenderAddon) {
                    <a class="cm-section-item" cdkMenuItem [href]="blenderAddon.url" target="_blank">
                        <i class="far fa-download cm-icon-default"></i>
                        Download Blender Addon ({{ blenderAddon.version }})
                    </a>
                }
            </div>
        </div>
    </ng-template>

    <ng-template #menuRenderServerDownload>
        <div class="cm-overlay-container cm-create-menu" cdkMenu>
            <div class="cm-section">
                @for (download of $renderServerDownloads(); track download.target) {
                    <a class="cm-section-item" cdkMenuItem [href]="download.url" target="_blank">
                        <i class="{{ download.icon }} cm-icon-default"></i>
                        {{ download.label }} ({{ download.version }})
                    </a>
                }
            </div>
        </div>
    </ng-template>

    <ng-template #menuUser>
        <div class="cm-overlay-container" cdkMenu>
            <div class="cm-user-details">
                <div class="cm-user-thumbnail-container" (click)="triggerFileUpload(); $event.stopPropagation()">
                    <cm-user-thumbnail class="cm-user-icon-image" size="medium" [user]="auth.$user()"></cm-user-thumbnail>
                    <div class="cm-camera-overlay">
                        <i class="far fa-camera"></i>
                    </div>
                </div>
                <div class="cm-user-details-name">
                    {{ auth.$user()?.name ?? "" }}
                    @if (silo.$silo(); as activeSilo) {
                        · {{ activeSilo.label }}
                    }
                </div>
                <div class="cm-user-details-email">{{ auth.$user()?.email ?? "" }}</div>
            </div>

            @if (can.read.menu("authenticateAsStaff")) {
                <div class="cm-user-menu-items">
                    <div class="cm-user-menu-item-container" [cdkMenuTriggerFor]="systemRolesMenu" [cdkMenuPosition]="menuPositionSystemRoles" cdkMenuItem>
                        <div class="cm-user-menu-item">
                            <i class="far fa-user cm-user-menu-item-icon cm-icon-default"></i>
                            System role
                        </div>
                        <i class="far fa-chevron-right"></i>
                    </div>
                </div>
            }
            @if (can.read.menu("authenticateAsSelfService")) {
                <div class="cm-user-menu-items">
                    <div class="cm-user-menu-item-container" [cdkMenuTriggerFor]="selfServiceMenu" [cdkMenuPosition]="menuPositionSystemRoles" cdkMenuItem>
                        <div class="cm-user-menu-item">
                            <i class="far fa-circle-user cm-user-menu-item-icon cm-icon-default"></i>
                            Self-service
                        </div>
                        <i class="far fa-chevron-right"></i>
                    </div>
                </div>
            }
            @if ($showOrganizationSwitcher()) {
                <div class="cm-user-menu-items">
                    <div class="cm-user-menu-item-container" [cdkMenuTriggerFor]="organizationsMenu" [cdkMenuPosition]="menuPositionNested" cdkMenuItem>
                        <div class="cm-user-menu-item"><i class="far fa-building cm-user-menu-item-icon cm-icon-default"></i> Organization</div>
                        <i class="far fa-chevron-right"></i>
                    </div>
                </div>
            }
            @if (can.read.menu("organizationSettings")) {
                <div class="cm-user-menu-items">
                    <div class="cm-user-menu-item-container" (click)="openOrganizationSettings()" cdkMenuItem>
                        <div class="cm-user-menu-item"><i class="far fa-building cm-user-menu-item-icon cm-icon-default"></i> Organization settings</div>
                    </div>
                </div>
            }
            @if (can.read.menu("authenticateAsStaff") || can.read.menu("organizationSettings") || $showOrganizationSwitcher()) {
                <div class="cm-horizontal-line"></div>
            }
            <div class="cm-user-menu-items">
                <div class="cm-user-menu-item-container" cdkMenuItem (click)="logout()">
                    <div class="cm-user-menu-item">
                        <i class="far fa-sign-out cm-user-menu-item-icon cm-icon-default"></i>
                        Log out
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #systemRolesMenu>
        <div class="cm-overlay-container" cdkMenu>
            @if (can.read.menu("authenticateAsStaff")) {
                <div class="cm-user-menu-item-container" cdkMenuItem (click)="activateSystemRole(SystemRole.Staff)">
                    <div class="cm-user-menu-item" [class.cm-menu-item-selected]="silo.$silo()?.systemRole === SystemRole.Staff">Staff</div>
                </div>
            }
            @if (can.read.menu("authenticateAsSuperadmin")) {
                <div class="cm-user-menu-item-container" cdkMenuItem (click)="activateSystemRole(SystemRole.Superadmin)">
                    <div class="cm-user-menu-item" [class.cm-menu-item-selected]="silo.$silo()?.systemRole === SystemRole.Superadmin">Superadmin</div>
                </div>
            }
        </div>
    </ng-template>

    <!-- Staff-only preview: browse colormass with a forced self-service accountType to exercise the self-service UI. -->
    <ng-template #selfServiceMenu>
        <div class="cm-overlay-container" cdkMenu>
            <div class="cm-user-menu-item-container" cdkMenuItem (click)="activateSelfService(AccountType.SelfServiceTrial)">
                <div class="cm-user-menu-item" [class.cm-menu-item-selected]="silo.$silo()?.organization?.accountType === AccountType.SelfServiceTrial">
                    Trial
                </div>
            </div>
            <div class="cm-user-menu-item-container" cdkMenuItem (click)="activateSelfService(AccountType.SelfServicePaid)">
                <div class="cm-user-menu-item" [class.cm-menu-item-selected]="silo.$silo()?.organization?.accountType === AccountType.SelfServicePaid">
                    Paid
                </div>
            </div>
            <div class="cm-user-menu-item-container" cdkMenuItem (click)="activateSelfService(AccountType.SelfServiceFree)">
                <div class="cm-user-menu-item" [class.cm-menu-item-selected]="silo.$silo()?.organization?.accountType === AccountType.SelfServiceFree">
                    Free
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #organizationsMenu>
        <div class="cm-overlay-container cm-organizations-menu" cdkMenu>
            @for (organization of $availableOrganizations(); track organization.id) {
                <div class="cm-user-menu-item-container" cdkMenuItem (click)="activateOrganization(organization)">
                    <div class="cm-organization-menu-item">
                        <div class="cm-user-menu-item" [class.cm-menu-item-selected]="silo.$silo()?.organization?.id === organization.id">
                            {{ organization.name }}
                        </div>
                        @if (auth.isStaff()) {
                            <div class="cm-organization-type">{{ organizationTypeName(organization) }}</div>
                        }
                    </div>
                </div>
            }
            @for (membership of $availableMemberships(); track membership.organization.id) {
                <div class="cm-user-menu-item-container" cdkMenuItem (click)="activateMembership(membership)">
                    <div class="cm-organization-menu-item">
                        <div class="cm-user-menu-item" [class.cm-menu-item-selected]="silo.$silo()?.membership?.id === membership.id">
                            {{ membership.organization.name }}
                        </div>
                    </div>
                </div>
            }
        </div>
    </ng-template>
</div>
